<template>
  <div>
    <v-dialog v-model="dialogValue" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="data">
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="dialogValue = false">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <v-toolbar-title>Payroll Lines - {{ data.lastName }}, {{ data.firstName }}</v-toolbar-title>
        </v-toolbar>

        <v-container pt-5>
          <v-layout row wrap pt-5>
            <v-flex xs12>
              <v-card>
                <v-toolbar flat color="white">
                  <v-spacer />
                  <v-btn color="secondary" dark @click="addNewDialog = true">
                    New Payroll
                  </v-btn>
                </v-toolbar>
                <v-data-table :headers="headers" :items="listData" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" class="elevation-1" :rows-per-page-items="rowsPerPageItems">
                  <v-progress-linear slot="progress" color="secondary" indeterminate />
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.date | formatShortDate }}</td>
                    <td>{{ props.item.payMethod }}</td>
                    <td class="text-xs-right">
                      ${{ props.item.amount }}
                    </td>
                    <td class="text-xs-right">
                      <v-icon class="mr-3" @click="editItem(props.item)">
                        far fa-edit
                      </v-icon>
                      <v-icon @click="deleteItem(props.item)">
                        far fa-trash-alt
                      </v-icon>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addNewDialog" max-width="600px" lazy>
      <v-card>
        <v-alert :value="alertMessage" type="error">
          <ul v-if="Array.isArray(alertMessage)">
            <li v-for="(message, index) in alertMessage" :key="index">
              {{ message }}
            </li>
          </ul>
          <div v-else>
            {{ alertMessage }}
          </div>
        </v-alert>
        <v-form @submit.prevent="processAddNew">
          <v-card-title>
            <span class="headline">
              Create Payroll Line
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap row justify-center>
                <v-flex xs10>
                  <v-menu v-model="newPayrollForm.dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" v-model="newDateFormatted" label="Pay Date" prepend-icon="event" readonly :error-messages="errors.collect('date')" name="date" />
                    <v-date-picker v-model="newPayrollForm.date" color="secondary" @input="newPayrollForm.dateMenu = false" />
                  </v-menu>
                </v-flex>
                <v-flex xs10>
                  <v-select v-model="newPayrollForm.payMethod" :items="payTypeOptions" name="payMethod" label="Pay Method*" required :error-messages="errors.collect('payMethod')" />
                </v-flex>
                <v-flex xs10>
                  <v-text-field v-model="newPayrollForm.amount" name="amount" label="Amount*" required :error-messages="errors.collect('amount')" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <span class="pl-4">
              <small>*indicates required field</small>
            </span>
            <v-spacer />
            <v-btn flat @click="addNewDialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" flat :loading="savingNew" @click="processAddNew">
              Save Changes
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateDialog" max-width="600px" lazy>
      <v-card>
        <v-alert :value="alertMessage" type="error">
          <ul v-if="Array.isArray(alertMessage)">
            <li v-for="(message, index) in alertMessage" :key="index">
              {{ message }}
            </li>
          </ul>
          <div v-else>
            {{ alertMessage }}
          </div>
        </v-alert>
        <v-form @submit.prevent="processUpdate">
          <v-card-title>
            <span class="headline">
              Update Payroll Line
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap row justify-center>
                <v-flex xs10>
                  <v-menu v-model="updatePayrollForm.dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" v-model="updateDateFormatted" label="Pay Date" prepend-icon="event" readonly :error-messages="errors.collect('date')" name="date" />
                    <v-date-picker v-model="updatePayrollForm.date" color="secondary" @input="updatePayrollForm.dateMenu = false" />
                  </v-menu>
                </v-flex>
                <v-flex xs10>
                  <v-select v-model="updatePayrollForm.payMethod" :items="payTypeOptions" name="payMethod" label="Pay Method*" required :error-messages="errors.collect('payMethod')" />
                </v-flex>
                <v-flex xs10>
                  <v-text-field v-model="updatePayrollForm.amount" name="amount" label="Amount*" required :error-messages="errors.collect('amount')" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <span class="pl-4">
              <small>*indicates required field</small>
            </span>
            <v-spacer />
            <v-btn flat @click="updateDialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" flat :loading="savingUpdate" @click="processUpdate">
              Save Changes
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';

  export default {
    props: {
      data: {
        type: Object,
        default: () => { },
      },

      dialog: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      payTypeOptions: window.payTypes,
      loading: true,
      listData: [],
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
      pagination: {
        descending: false, page: 1, rowsPerPage: 20, sortBy: 'id', totalItems: 0,
      },
      headers: [
        { text: 'ID #', align: 'left', value: 'id' },
        { text: 'Pay Date', value: 'date', align: 'left' },
        { text: 'Pay Method', value: 'payMethod', align: 'left' },
        { text: 'Amount', value: 'amount', align: 'right' },
        { align: 'right', value: '' },
      ],

      addNewDialog: false,
      savingNew: false,
      defaultNewPayrollForm: {
        date: new Date().toISOString().substr(0, 10),
        payMethod: '',
        amount: '',
        dateMenu: false,
      },
      newPayrollForm: {
        date: new Date().toISOString().substr(0, 10),
        payMethod: '',
        amount: '',
        dateMenu: false,
      },

      updateDialog: false,
      savingUpdate: false,
      defaultUpdatePayrollForm: {
        id: null,
        date: new Date().toISOString().substr(0, 10),
        payMethod: '',
        amount: '',
        dateMenu: false,
      },
      updatePayrollForm: {
        id: null,
        date: new Date().toISOString().substr(0, 10),
        payMethod: '',
        amount: '',
        dateMenu: false,
      },
    }),

    computed: {
      newDateFormatted() {
        return this.newPayrollForm.date ? moment(this.newPayrollForm.date).format('MMMM D, YYYY') : '';
      },

      updateDateFormatted() {
        return this.updatePayrollForm.date ? moment(this.updatePayrollForm.date).format('MMMM D, YYYY') : '';
      },

      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },
    },

    watch: {
      dialogValue(val) {
        if (val) this.getPayrollItems();
      },

      updateDialog(val) {
        if (!val) {
          setTimeout(() => {
            Object.keys(this.updatePayrollForm).filter(key => key in this.defaultUpdatePayrollForm).forEach(key => this.updatePayrollForm[key] = this.defaultUpdatePayrollForm[key]); // eslint-disable-line
            this.clearErrors();
          }, 300);
        }
      },

      addNewDialog(val) {
        if (!val) {
          setTimeout(() => {
            Object.keys(this.newPayrollForm).filter(key => key in this.defaultNewPayrollForm).forEach(key => this.newPayrollForm[key] = this.defaultNewPayrollForm[key]); // eslint-disable-line
            this.clearErrors();
          }, 300);
        }
      },
    },

    methods: {
      async getPayrollItems() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        const { data } = await axios.get(`/api/human-resources/payable-entity-tax-data/pay-items/${this.data.taxableEntityId}/list?currentPage=${page}&pageSize=${rowsPerPage}`);
        this.listData = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
      },

      async processAddNew() {
        const result = await this.startFormProcessing();
        if (!result) return;
        this.savingNew = true;
        try {
          await axios.post(`/api/human-resources/payable-entity-tax-data/pay-items/${this.data.taxableEntityId}/create`, this.newPayrollForm);
          await this.getPayrollItems();
          this.addNewDialog = false;
        } catch (error) {
          this.processErrors(error, this.newPayrollForm);
        } finally {
          this.savingNew = false;
        }
      },

      async processUpdate() {
        const result = await this.startFormProcessing();
        if (!result) return;
        this.savingUpdate = true;
        try {
          await axios.patch(`/api/human-resources/payable-entity-tax-data/pay-items/${this.data.taxableEntityId}/update/${this.updatePayrollForm.id}`, this.updatePayrollForm);
          await this.getPayrollItems();
          this.updateDialog = false;
        } catch (error) {
          this.processErrors(error, this.updatePayrollForm);
        } finally {
          this.savingUpdate = false;
        }
      },

      editItem(item) {
        Object.keys(this.updatePayrollForm).filter(key => key in item).forEach(key => this.updatePayrollForm[key] = item[key]); // eslint-disable-line
        this.updateDialog = true;
      },


      async deleteItem(item) {
        const result = confirm('Are you sure you want to delete this item?'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/human-resources/payable-entity-tax-data/pay-items/${item.taxableEntityId}/delete/${item.id}`);
          await this.getPayrollItems();
        }
      },
    },
  };
</script>